/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import * as Msdyn365 from '@msdyn365-commerce/core';

import { IObrienModalWindowData } from './obrien-modal-window.data';
import { IObrienModalWindowProps } from './obrien-modal-window.props.autogenerated';

export interface IObrienModalWindowViewProps extends IObrienModalWindowProps<IObrienModalWindowData> {

    modalTitle?: React.ReactNode;
    modalContent: string;
    modalImage: React.ReactNode;
    modalButtonText: string;
    modalButtonLink: string;

}



/**
 *
 * ObrienModalWindow component
 * @extends {React.PureComponent<IObrienModalWindowProps<IObrienModalWindowData>>}
 */
class ObrienModalWindow extends React.PureComponent<IObrienModalWindowProps<IObrienModalWindowData>> {
    public render(): JSX.Element | null {

        const { config } = this.props;

        const { 
            modalTitle,
            modalContent,
            modalImage
        } = this.props.config;

        const ModalButtonLink = config.modalButtonLink ? config.modalButtonLink : '';
        const ModalButtonText = config.modalButtonText ? config.modalButtonText : '';

        const ModalTitle = modalTitle && (
            <Msdyn365.Text
              tag={modalTitle.tag || 'h2'}
              text={modalTitle.text}
              editProps={{onEdit: this.handleTextChange, requestContext:this.props.context.request}}
            />
        );
        const ModalContent = modalContent && (
            <Msdyn365.RichTextComponent
                text={modalContent}
                editProps={{ onEdit: this.handleParagraphChange, requestContext: this.props.context.request }}
            />
        );
        const imageProps = {
            gridSettings: this.props.context.request.gridSettings || {},
            imageSettings: modalImage && modalImage.imageSettings,
        };

        const ModalImage = modalImage && (
            <Msdyn365.Image {...modalImage} {...imageProps} editProps ={{key:this.props.config.modalImage || {}, requestContext: this.props.context.request}}/>
        );

        const ObrienModalProps = {
            ...this.props,
            modalTitle: ModalTitle,
            modalContent: ModalContent,
            modalImage: ModalImage,
            modalButtonText: ModalButtonText,
            modalButtonLink: ModalButtonLink
        };

        return this.props.renderView(ObrienModalProps) as React.ReactElement;
    }
    public handleTextChange = (event: Msdyn365.ContentEditableEvent) => this.props.config.modalTitle!.text = event.target.value;
    public handleParagraphChange = (event: Msdyn365.ContentEditableEvent) => this.props.config.modalContent! = event.target.value;
}

export default ObrienModalWindow;
